import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import SEOHead from '../components/SEOHead'

const PrivacyPolicy = () => {
  const { t } = useTranslation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className="section-padding bg-[#0a0a0f] min-h-screen pt-32 pb-16">
      <SEOHead
        title={t('privacy.title', 'Privacy Policy — nodatx')}
        description={t('privacy.description', "Learn how nodatx protects your personal data. Our Privacy Policy explains how we collect, use, and safeguard your information when using our n8n automation services.")}
        canonical="https://nodatx.com/privacy"
      />
      <div className="container-custom max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 border-b border-white/10 pb-6">{t('privacy.heading', 'Privacy Policy')}</h1>
        
        <div className="space-y-8 text-gray-300 leading-relaxed text-lg">
          <section>
            <p className="mb-4">
              {t('privacy.intro', 'Welcome to nodatx ("we", "our", "the Company"). Your privacy and data protection are our top priorities. This Privacy Policy explains how we collect, use, and protect your information when you visit our website or use our business automation and system integration services.')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-purple-400 mb-4">{t('privacy.section1', '1. Information We Collect')}</h2>
            <p className="mb-4">{t('privacy.section1Desc', 'We collect information in two primary ways:')}</p>
            <ul className="list-disc list-inside space-y-2 mr-4">
              <li><strong>{t('privacy.section1Item1Label', 'Data you provide directly:')}</strong> {t('privacy.section1Item1', 'such as your name, email address, phone number, and company details when you fill out a contact form or book a call with us.')}</li>
              <li><strong>{t('privacy.section1Item2Label', 'Technical information:')}</strong> {t('privacy.section1Item2', 'such as your IP address, browser type, and pages you visited on our website, for the purpose of improving your user experience.')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-purple-400 mb-4">{t('privacy.section2', '2. How We Use Your Information')}</h2>
            <ul className="list-disc list-inside space-y-2 mr-4">
              <li>{t('privacy.section2Item1', 'To communicate with you regarding your inquiries or to initiate projects.')}</li>
              <li>{t('privacy.section2Item2', 'To design and build workflows and integrations tailored to your business using the n8n platform.')}</li>
              <li>{t('privacy.section2Item3', 'To improve our website and services based on customer interactions.')}</li>
              <li>{t('privacy.section2Item4', 'To send important updates, invoices, or technical information related to your projects.')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-purple-400 mb-4">{t('privacy.section3', '3. Data Protection and Third-Party Systems')}</h2>
            <p className="mb-4">
              {t('privacy.section3Desc', 'We provide automation services that rely on platforms like n8n and others. When executing any project, we ensure that any data passing through our servers is protected and encrypted. We do not sell, rent, or trade your personal information with any third party for any commercial purpose.')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-purple-400 mb-4">{t('privacy.section4', '4. Your Rights as a Client')}</h2>
            <p className="mb-4">
              {t('privacy.section4Desc', 'You have the right to request a copy of the information we hold about you, or to request its correction or complete deletion from our records at any time. If you wish to make any of these requests, you can contact us directly.')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-purple-400 mb-4">{t('privacy.section5', '5. Changes to This Privacy Policy')}</h2>
            <p className="mb-4">
              {t('privacy.section5Desc', 'We may update our Privacy Policy from time to time. When this happens, we will post the update here along with a revised "Last updated" date at the bottom of the page. We encourage you to review this page regularly to stay informed about how we protect your data.')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-purple-400 mb-4">{t('privacy.section6', '6. Contact Us')}</h2>
            <p className="mb-4">
              {t('privacy.section6Desc', 'If you have any questions or inquiries about this Privacy Policy or our services in general, please reach out to us at:')}
            </p>
            <p className="text-white font-semibold">
              <a href="mailto:support@nodatx.com" className="text-purple-400 hover:underline transition-all">support@nodatx.com</a>
            </p>
          </section>
        </div>
        
        <div className="mt-16 pt-8 border-t border-white/10 text-center text-gray-500 text-sm">
          {t('privacy.lastUpdated', 'Last updated: February 21, 2026')}
        </div>
      </div>
    </main>
  )
}

export default PrivacyPolicy